import type { ReactNode } from 'react'
import { Mail } from 'lucide-react'
import { WhatsAppIcon, TelegramIcon, DiscordIcon, TeamsIcon } from '@/frontend/components/DigitalWorkers/channelIcons'
import type { DigitalWorkerDetail } from '@/frontend/pages/Dashboard/DigitalWorkers/types'

export interface ConnectedChannel {
  key: string
  label: string
  icon: ReactNode
}

// Ficha do colaborador (SZ-1598): the connected-channel badges derive only
// from data the Show page already receives — no extra fetches on mount.
// Slack has no per-worker connection field yet (see SlackComingSoonCard), so
// it can never appear here until the backend exposes one.
export function connectedChannels(worker: DigitalWorkerDetail): ConnectedChannel[] {
  const gatewayChannelsSupported = worker.runtime_capabilities.gateway_channels.supported
  return [
    ...(worker.runtime_capabilities.whatsapp_cloud.supported && worker.whatsapp_provider !== 'none'
      ? [{ key: 'whatsapp', label: 'WhatsApp', icon: <WhatsAppIcon /> }]
      : []),
    ...(worker.runtime_capabilities.telegram.supported && worker.telegram_connection_status === 'active'
      ? [{ key: 'telegram', label: 'Telegram', icon: <TelegramIcon /> }]
      : []),
    ...(gatewayChannelsSupported && worker.discord_bot_key
      ? [{ key: 'discord', label: 'Discord', icon: <DiscordIcon /> }]
      : []),
    ...(gatewayChannelsSupported && worker.msteams_connected
      ? [{ key: 'msteams', label: 'Teams', icon: <TeamsIcon /> }]
      : []),
    ...(worker.stationzero_email_account_status === 'provisioned'
      ? [{ key: 'email', label: 'E-mail', icon: <Mail className="h-3 w-3 text-muted-foreground" aria-hidden="true" /> }]
      : []),
  ]
}

// "WhatsApp, Discord e E-mail" — pt-BR conjunction list without relying on
// Intl.ListFormat (keeps the TS lib target untouched).
export function listChannelLabels(channels: ConnectedChannel[]): string {
  const labels = channels.map((channel) => channel.label)
  if (labels.length <= 1) return labels[0] ?? ''
  return `${labels.slice(0, -1).join(', ')} e ${labels[labels.length - 1]}`
}
